import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import { SortOptionsDialog } from '../Filters/SortOptionsDialog';
import { updateFilters } from '../../../actions/areas/dailyPlanning/filters';
import { SearchFilter } from '../Filters/SearchFilter';
import { popUpModalStyles } from '../../../theme/AllocateBaseTheme';
import { CardItemsColumnHtml, sortClinicianOptions } from '../timeline/timelineConstants';

const useStyles = makeStyles({
  clinicianPopModal: {
    backgroundColor: '#333333',
    color: '#fff',
    padding: '5px',
    minWidth: '135px',
  },
});
export function ClinicianCards({
  setFilterValue,
  clinicians,
  clinciianFilterOption,
  clinciianSortingOptions,
  isMileageCapEnabled,
  includeTreatments,
  hasNoTimeSlots,
}) {
  const search = useSelector(state => state.areas.dailyPlanning.filters.clinician);
  const classes = useStyles();
  const [showMoreAnchor, setShowMoreAnchor] = useState(null);
  const dispatch = useDispatch();
  const [clinician, setClinician] = useState('');

  function handleChange(name, value) {
    setClinician(value);
    dispatch(updateFilters({ clinician: value, grades: [''] }));
  }
  return (
    <div className="timeline-cards-container fix-column">
      <div className="timeline-input-wrapper timeline-select-input">
        <div className="timeline-form-map-input">
          <SearchFilter
            width="100%"
            filterKey={'clinician'}
            label="Find Clinicians"
            fullWidth
            filterValue={search || clinician}
            onChange={(name, value) => handleChange(name, value)}
            id="clinician_search"
          />

          <span className="icon-extend icon-search icon-small" />
        </div>
        <div className="form-map-icon">
          <Tooltip title="Sorting">
            <span
              id="sort-clinician-cards"
              className="icon-extend icon-sorting icon-small"
              role="button"
              tabIndex={0}
              onClick={event => setShowMoreAnchor(event.target)}
            />
          </Tooltip>

          <SortOptionsDialog
            clinicianModal={classes.clinicianPopModal}
            popUpModal={popUpModalStyles.popUpModal}
            open={showMoreAnchor !== null}
            anchorEl={showMoreAnchor}
            handleClose={() => setShowMoreAnchor(null)}
            width="100%"
            className="pop-over"
            fullWidth
            data={clinciianSortingOptions}
            filterKey={'sortClinicianFilter'}
            filterValue={clinciianFilterOption || sortClinicianOptions[0].id}
            onChange={(name, value) => setFilterValue(name, value)}
          />
        </div>
      </div>
      <CardItemsColumnHtml
        items={clinicians}
        isMileageCapEnabled={isMileageCapEnabled}
        includeTreatments={includeTreatments}
        hasNoTimeSlots={hasNoTimeSlots}
      />
    </div>
  );
}
